import { Injectable } from '@angular/core'
import { CollectionRepository } from '@engineering11/web-api-firebase'
import { COLLECTIONS, IJobPostAutomation } from 'shared-lib'

@Injectable({ providedIn: 'root' })
export class JobPostAutomationRepository extends CollectionRepository<IJobPostAutomation> {
  protected COLLECTION = COLLECTIONS.AUTOMATION_CONFIG
}
